document.querySelectorAll(".megaDealSlider").forEach((slider, index) => {
    const prevArrow = slider.parentElement.querySelector(".prev"),
          nextArrow = slider.parentElement.querySelector(".next");

    new Swiper(slider, {
        effect: "slide",
        speed: 1000,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow
        },
        breakpoints: {
            150: {
                slidesPerView: 1.4,
                spaceBetween: 10
            },
            576: {
                slidesPerView: 2.3,
                spaceBetween: 15
            },
            769: {
                slidesPerView: 2.6,
                spaceBetween: 25
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1201: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1650:{
                slidesPerView: 4,
                spaceBetween: 30
            }
        }
    });
});


document.querySelectorAll(".ourClientSlider").forEach((slider, index) => {
    const prevArrow = slider.parentElement.querySelector(".prev"),
          nextArrow = slider.parentElement.querySelector(".next");

    new Swiper(slider, {
        effect: "slide",
        speed: 1000,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow
        },
        breakpoints: {
            150: {
                slidesPerView: 1.4,
                spaceBetween: 10
            },
            576: {
                slidesPerView: 2.3,
                spaceBetween: 15
            },
            769: {
                slidesPerView: 2.7,
                spaceBetween: 20
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1201: {
                slidesPerView: 3.6,
                spaceBetween: 20
            },
            1650:{
                slidesPerView: 4,
                spaceBetween: 20
            }
        }
    });
});

document.querySelectorAll(".reviewsSlider").forEach((slider, index) => {
    const prevArrow = slider.parentElement.querySelector(".prev"),
          nextArrow = slider.parentElement.querySelector(".next");

    new Swiper(slider, {
        effect: "slide",
        speed: 1000,
        // loop:true,
        // autoplay:true,
        // delay:0,
        // centeredSlides: true,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow
        },
        breakpoints: {
            150: {
                slidesPerView: 1.3,
                spaceBetween: 10
            },
            576: {
                slidesPerView: 2.3,
                spaceBetween: 15
            },
            769: {
                slidesPerView: 2.6,
                spaceBetween: 20
            },
            1025: {
                slidesPerView: 2.4,
                spaceBetween: 20
            },
            1201: {
                slidesPerView: 2.8,
                spaceBetween: 20
            },
            1650:{
                slidesPerView: 3.5,
                spaceBetween: 20
            }
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".reviewVideo-box");
    let currentlyPlaying = null;
    videoBoxes.forEach((box) => {
        const video = box.querySelector("video"),
        playBtn = box.querySelector(".video-playBtn");
        (playBtn.addEventListener("click", function () {
        if (currentlyPlaying === video) {
            (video.pause(),
            box.classList.remove("active"),
            playBtn.classList.remove("active"),
            (currentlyPlaying = null));
            return;
        }
        (currentlyPlaying &&
            (currentlyPlaying.pause(),
            currentlyPlaying
            .closest(".why-choose-video-box")
            .classList.remove("active"),
            currentlyPlaying
            .closest(".why-choose-video-box")
            .querySelector(".video-playBtn")
            .classList.remove("active")),
            video.play(),
            box.classList.add("active"),
            playBtn.classList.add("active"),
            (currentlyPlaying = video));
        }),
        video.addEventListener("pause", function () {
            currentlyPlaying === video &&
            (box.classList.remove("active"),
            playBtn.classList.remove("active"),
            (currentlyPlaying = null));
        }),
        video.addEventListener("ended", function () {
            (box.classList.remove("active"),
            playBtn.classList.remove("active"),
            (currentlyPlaying = null));
        }));
    });
});

document.querySelectorAll(".productVideoSlider").forEach((slider, index) => {
    const prevArrow = slider.parentElement.querySelector(".prev"),
          nextArrow = slider.parentElement.querySelector(".next");

    new Swiper(slider, {
        effect: "slide",
        speed: 1000,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow
        },
        breakpoints: {
            150: {
                slidesPerView: 1.7,
                spaceBetween: 10
            },
            576: {
                slidesPerView: 3,
                spaceBetween: 15
            },
            769: {
                slidesPerView: 2.4,
                spaceBetween: 20
            },
            1025: {
                slidesPerView:2.4,
                spaceBetween: 12
            },
            1201: {
                slidesPerView: 2.5,
                spaceBetween: 15
            },
            1650:{
                slidesPerView: 3,
                spaceBetween: 20
            }
        }
    });
});

document.querySelectorAll(".testimonialSlider").forEach((slider, index) => {
    const prevArrow = slider.parentElement.querySelector(".prev"),
          nextArrow = slider.parentElement.querySelector(".next");

    new Swiper(slider, {
        effect: "slide",
        speed: 1000,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow
        },
        breakpoints: {
            150: {
                slidesPerView: 1.4,
                spaceBetween: 10
            },
            576: {
                slidesPerView: 2.3,
                spaceBetween: 15
            },
            769: {
                slidesPerView: 2.6,
                spaceBetween: 25
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1201: {
                slidesPerView: 3,
                spaceBetween: 25
            },
            1650:{
                slidesPerView: 4,
                spaceBetween: 30
            }
        }
    });
});


document.addEventListener("DOMContentLoaded", () => {
    const accordionHeader = document.querySelectorAll(".accordion--header");

    accordionHeader.forEach((header) => {
        header.addEventListener("click", function () {
        const accordionItem = this.parentElement;
        const accordionBody = this.nextElementSibling;
        const accordionIcon = this.querySelector(".accordion-icon");

        // Optional: Close other open FAQ items automatically (Accordion Style)
        document.querySelectorAll(".accordion--item").forEach((item) => {
            if (item !== accordionItem && item.classList.contains("active")) {
                item.classList.remove("active");
                item.querySelector(".accordion--body").style.maxHeight = null;
                item.querySelector('.plus-sign').style.display = 'block';
                item.querySelector('.minus-sign').style.display = 'none';
            }
        });

        // Toggle active status for current item
        accordionItem.classList.toggle("active");

        if (accordionItem.classList.contains("active")) {
            accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
            accordionIcon.querySelector('.plus-sign').style.display = 'none';
            accordionIcon.querySelector('.minus-sign').style.display = 'block';
        } else {
            accordionBody.style.maxHeight = null;
            accordionIcon.querySelector('.plus-sign').style.display = 'block';
            accordionIcon.querySelector('.minus-sign').style.display = 'none';

        }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".logo_rows");
  if (!container) return;


  const items = Array.from(container.children);


  items.forEach((item) => {
    container.appendChild(item.cloneNode(true));
  });


  const totalWidth = container.scrollWidth / 2;


  gsap.to(container, {
    x: "-=" + totalWidth,
    duration: 30,
    ease: "none",
    repeat: -1,
    modifiers: {
      x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth)
    }
  });
});






{
  AOS.init();
}